import * as React from "react";

export const Component = () => (
    <div>
        <h2>asdasd</h2>
    </div>
)



// WEBPACK FOOTER //
// ./client/app.tsx